module.exports = __webpack_public_path__ + "img/item5.5f1536cb.png";